import { Chip, Stack, Typography } from "@mui/material";
import { IProduct } from "mobx-stores/_models/products/product";
type ProductNameAndActiveInfoProps = {
  product: IProduct;
};
export const ProductNameAndActiveInfo = ({
  product,
}: ProductNameAndActiveInfoProps) => {
  return (
    <Stack direction={"row"} spacing={1} alignItems={"center"}>
      <Typography>{product.name || ""}</Typography>
      {product.isDisabled && (
        <Chip
          variant="outlined"
          label={"Ngưng SX"}
          color="error"
          size="small"
        ></Chip>
      )}
    </Stack>
  );
};
